import { useEffect, useMemo } from 'react'

import { EventsEmbed } from '@components/embeds/EventsEmbed'
import { decodeEmbedConfig } from '@utils/embeds/embedConfig'
import { useEventsFeed } from '@utils/embeds/eventsFeed'
import { setFont } from '@utils/embeds/fonts'
import { useHostViewportHeight } from '@utils/embeds/hostViewport'
import { defaultBrand } from '@utils/embeds/theme'

export type PublicEventsEmbedProps = {
  feedUrl: string
  country: string
  sidebarColor: string | null
  googleMapsApiKey: string | null
}

function usePostHeightToHost() {
  useEffect(() => {
    if (window.parent === window) return
    const post = () => window.parent.postMessage({ type: 'resizeIframe', height: document.body.scrollHeight }, '*')
    const observer = new ResizeObserver(post)
    observer.observe(document.body)
    post()
    return () => observer.disconnect()
  }, [])
}

export default function PublicEventsEmbed({
  feedUrl,
  country,
  sidebarColor,
  googleMapsApiKey,
}: PublicEventsEmbedProps) {
  const config = useMemo(() => decodeEmbedConfig(window.location.search), [])
  const brand = config.color ?? defaultBrand(sidebarColor)
  const feed = useEventsFeed({ feedUrl, config })
  const screenHeight = useHostViewportHeight()

  usePostHeightToHost()

  // The card's calendar and share menus portal to <body>, outside the embed.
  useEffect(() => setFont(document.body, config.font), [config.font])

  return (
    <main>
      <EventsEmbed
        config={config}
        brand={brand}
        feed={feed}
        country={country}
        googleMapsApiKey={googleMapsApiKey}
        screenHeight={screenHeight}
      />
    </main>
  )
}
